<template>
  <div :class="{'mt-xxl': !isMobile}">
    <ActionHeader
      v-if="isMobile"
      class="col"
      page-header>
      Returning
    </ActionHeader>
    <h4
      v-else
      class="col col-12 text-center my-md">
      Returning Quarterly Rentals
    </h4>
    <div
      v-if="isMobile"
      class="bg-origami p-md">
      <p
        class="text-center"
        :class="{'small-text': isMobile}">
        Select the items you’re returning today.
      </p>
    </div>
    <p
      v-else
      class="text-center my-md">
      Select the items you’re returning today.
    </p>
    <div>
      <div v-if="readyToReturnItems.length > 0">
        <h6 class="m-md">
          Ready to Return
        </h6>
        <ReviewSelectItemsList
          title=""
          :package-items="readyToReturnItems"
          :selected-items="selectedItems"
          :show-back-button="false"
          @selected="onSelectItem"/>
      </div>
      
      <div v-if="earlyReturnItems.length > 0">
        <h6 class="m-md">
          Early Returns
        </h6>
        <p
          class="ms-md mb-md"
          :class="{'small-text': isMobile}">
          No refunds will be issued for early returns.
        </p>
        <ReviewSelectItemsList
          title=""
          :package-items="earlyReturnItems"
          :selected-items="selectedItems"
          :show-back-button="false"
          @selected="onSelectItem"/>
      </div>
      
      <div
        v-if="readyToReturnItems.length === 0 && earlyReturnItems.length === 0"
        class="py-xxl text-center w-100">
        <b>
          You have no items ready to return.
        </b>
      </div>
    </div>
    <div
      :class="isMobile
        ? 'col col-12 mobile-button swap-review-button'
        : 'd-flex justify-content-end mt-md mb-md me-md'">
      <BaseButton
        :disabled="selectedItems.length === 0"
        :text="returnText"
        @click="submit"/>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, onMounted, computed } from 'vue'
import { useRouter } from 'vue-router'
import { storeToRefs } from 'pinia'
import useScreenSize from '@shared/composables/screenSize.js'
import ReviewSelectItemsList from '../review/ReviewSelectItemsList.vue'
import BaseButton from '@shared/components/ADORN/BaseButton.vue'
import ActionHeader from '../global/sequin/ActionHeader.vue'
import { useQuarterlyRentalsStore } from '@/stores/quarterlyRentals.js'

const router = useRouter()
const quarterlyRentalsStore = useQuarterlyRentalsStore()
const { 
  readyToReturnItems, 
  earlyReturnItems, 
  allAvailableItems
} = storeToRefs(quarterlyRentalsStore)
const { 
  setItemsToReturn,
  initializePreselectedItems
} = quarterlyRentalsStore
const { isMobile } = useScreenSize()

const selectedItems = ref([])
const returnText = computed(() => `Return ${selectedItems.value.length > 0 ? selectedItems.value.length : ''} Item${selectedItems.value.length > 1 ? 's' : ''}`)
function initializePreselectedItemsFromStore () {
  if (selectedItems.value.length > 0) {
    return
  }
  
  const preselectedItems = initializePreselectedItems()
  if (preselectedItems && preselectedItems.length > 0) {
    selectedItems.value = preselectedItems
  }
}

function submit () {
  setItemsToReturn(selectedItems.value.slice())
  router.push({ name: 'quarterly-return-confirm' })
}

function onSelectItem (packageItem) {
  if (selectedItems.value.some(item => item.id === packageItem.id)) {
    selectedItems.value = selectedItems.value.filter(item => item.id !== packageItem.id)
  } else {
    selectedItems.value.push(packageItem)
  }
}

watch(allAvailableItems, () => {
  initializePreselectedItemsFromStore()
}, { immediate: false })

onMounted(() => {
  initializePreselectedItemsFromStore()
})
</script>

<style lang="scss" scoped>
  .mobile-button {
    padding: 12px;
    border-top: $default-border;
    background-color: $white;
    z-index: 2;
    position: fixed;
    bottom: 0;
    left: 0;
  }

  .list-padding {
    padding-bottom: 128px;
  }
</style>
